export default class CustomError extends Error {
    constructor(message, reason) {
        super(message);
        this.name = 'CustomError';
        this.reason = reason;
    }
}
